<template>
  <div>
    <van-popup round :close-on-click-overlay='false' v-model="loginShow1">
      <div class="login-choice-box">
        <ul>
          <li class="login" @click="goPage('login')">已开通账号 立即登录</li>
          <li class="reg" @click="goPage('reg')">我未注册 立即报名</li>
        </ul>
      </div>
    </van-popup>
  </div>
</template>
<script>
  import md5 from 'js-md5';
  import type from '@/utils/type';
  import util from '@/utils/util';


  export default {
    props: ['loginShow', 'paramsData', 'activityName'],
    data() {
      return {
        loginShow1: false,
      };
    },
    watch: {
      loginShow: {
        handler: function (val) {
          this.loginShow1 = val;
        },
        deep: true
      }
    },
    mounted() {
    },
    methods: {
      goPage(val) {
        console.log(this.$route.query, 'this.$route.querythis.$route.querythis.$route.query');
        let query = this.$route.query;
        query.activityName = this.activityName;
        if (val == 'login') {
          this.$router.push({
            path: '/home/login',
            query: query,
          });
        } else {
          this.$router.push({
            path: '/home/reg',
            query: query,
          });
        }
      },
    }
  };
</script>
<style scoped lang="less">
  .login-choice-box {
    width: 300px;
    padding: 20px;
    box-sizing: border-box;

    ul {
      li {
        border-radius: 8px;
        border: 1px solid #010212;
        font-size: 18px;
        font-weight: 400;
        line-height: 25px;
        margin: 12px 0;
        text-align: center;
        padding: 12px 0;
      }

      li.login {
        color: #010212;
      }

      li.reg {
        color: #FFFFFF;
        background: #010212;
      }
    }
  }
</style>
